import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-[1.5rem] bg-[#f9fafb] font-[Inter] text-[#111827]">
      <p className="m-0 text-[6rem] font-semibold leading-none text-[#0d9488]">404</p>
      <p className="m-0 text-[1.5rem] font-medium">Страница не найдена</p>
      <p className="m-0 text-[1rem] text-[#6b7280]">
        Возможно, ссылка устарела или была введена неверно
      </p>
      <Link
        to="/"
        className="rounded-[10px] bg-[#0d9488] px-[1.5rem] py-[1rem] text-[1rem] font-medium text-white transition-colors hover:bg-[#0b8278]"
      >
        На главную
      </Link>
    </div>
  )
}

export default NotFound
